import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { historyListAPI, historyDelAPI } from '../../../api/ocrAPI';
import { useAlert, useAppOcrOnOff, useRequest, useUserInfo } from '../../../hooks';
import OcrHeader from '../OcrHeader';
import OcrHistoryItem from './OcrHistoryItem';
import PopupTrigger from '../../common/PopupTrigger';
import Popup from '../../common/Popup';
import useAmplitude from '../../../hooks/useAmplitude';
import { TYPE } from '../../../constant';
// import { MESSAGE } from '../../../constant';
let hstSnoList = [];
const OcrHistory = () => {
  const [Alert] = useAlert();
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { appOcrOnOff } = useAppOcrOnOff();
  const { setAmplitudeLog } = useAmplitude();
  const [list, setList] = useState([]);
  const [choiceItem, setChoiceItem] = useState(null);
  const [listCnt, setListCnt] = useState(0);
  const [deletePopup, setDeletePopup] = useState(false);
  const [ historyDelAPICall ] = useRequest((data) => historyDelAPI(data));

  useEffect(() => {
    appOcrOnOff('Y');
    setAmplitudeLog({ eventCategory: 'ocr', eventName: 'ocr히스토리 조회' });
    historyListAPICall();
  }, []);

  const historyListAPICall = useCallback(async () => {
    try {
      const { learnerId } = info;
      const data = await historyListAPI({
        lrnMbrId: learnerId,
        // lrnMbrId: 'LRN20210812140000542',
      });
      if (data?.code === 'S000000') {
        const { resp } = data;
        setListCnt(resp.length);
        const result = _.chain(resp)
          .map((item) => {
            item.rgtnDt = moment(item.rgtnDt).format('YYYYMMDD');
            return item;
          })
          .groupBy('rgtnDt')
          .toPairs()
          .value();
        
        setList(result.reverse());
      }
    } catch (error) {
      console.log({ error });
    }
  }, []);

  const handleChecked = useCallback((e, type, item) => {
    // target.checked

    let isChecked = e.target.checked;
    
    if (type === 'all') {
      hstSnoList = [];
      handleCheckbox(isChecked);
      // 체크 되는 hstSno 세팅
      if (isChecked) {
        list.forEach((group) => {
          group[1].forEach((item) => hstSnoList.push(item.hstSno));
        });
      }
      
    } else {
      // 건 by 건 체크 박스 목록 선택 true, false
      setChoiceItem(item);
      if (!isChecked) _.remove(hstSnoList, (v) => v === item.hstSno);
      else hstSnoList.push(item.hstSno);

      // 건 by 건으로 전부 체크 했을 때 모두 선택 체크박스 true
      if (hstSnoList.length === listCnt) document.getElementById("input-chk_all").checked = true;
    }
  }, [list]);

  const handleDelete = useCallback( async () => {
    
    if (hstSnoList.length === 0) {
      Alert(t("LC_09_06.msg004"));
      return;
    }
    
    await historyDelAPICall({
      lrnMbrId: info.learnerId,
      // lrnMbrId: "LRN20210812140000542",
      hstSnoList,
    });

    hstSnoList = [];
    handleCheckbox(false);
    historyListAPICall();
    
  }, [hstSnoList]);

  const handleCheckbox = useCallback((isChecked) => {
    // 전체 체크 박스 목록 선택 true, false
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => checkbox.checked = isChecked);
  }, []);

  const handlePopup = useCallback(() => {
    setDeletePopup(!deletePopup);
  }, [deletePopup])

  const handleErrorDelete = useCallback(async () => {
    await historyDelAPICall({
      lrnMbrId: info.learnerId,
      hstSnoList: [choiceItem.hstSno],
    });
    hstSnoList = [];
    handleCheckbox(false);
    historyListAPICall();

  }, [choiceItem])

  return (
    <div className="layout-def layout-lc">
      <OcrHeader
        title={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? t("LC_09_06.msg001") : 'OCR 학습 히스토리'}
      />
      <div className="container">
        <div className="inner">
          <div className="ocr_history">
            <div className="upper_fix">
              <div className="left">
                <div className="custom-radio-wrap gray">
                  <input
                    type="checkbox"
                    id="input-chk_all"
                    onChange={(e) => handleChecked(e, 'all')}
                  />
                  <label htmlFor="input-chk_all">{t("LC_09_06.msg002")}</label>
                </div>
              </div>
              <div className="right">
                <button
                  type="button"
                  className="del"
                  onClick={handleDelete}
                >
                  {t("LC_09_06.msg003")}
                </button>
              </div>
            </div>
            <div className="inner_wrap">
              {
                (list && list.length > 0) && (
                  list.map((item, index) => (
                    <OcrHistoryItem
                      key={index}
                      dayItem={item}
                      setDeletePopup={setDeletePopup}
                      handleChecked={handleChecked}
                    />
                  ))
                )
              }
            </div>
          </div>
        </div>
      </div>
      {
        deletePopup && (
          <PopupTrigger 
            open={deletePopup}
          >
            <Popup 
              onConfirm={handleErrorDelete}
              onClose={handlePopup}
            >
              <p
                className="lc-alert_txt m-fw-normal"
                dangerouslySetInnerHTML={{ __html: t("LC_09_06.msg005") }}
              />
            </Popup>
          </PopupTrigger>
        )
      }
    </div>
  );
};

export default OcrHistory;
